import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { LifeBuoy, Loader2 } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { Panel } from "@/components/common/Panel";
import { EmptyState } from "@/components/common/EmptyState";
import { formatDate } from "@/lib/nav";

export default function Support() {
  const [rows, setRows] = useState(null);

  const load = useCallback(() => {
    api.get("/cockpit/sessions").then((r) => setRows(r.data.sessions || [])).catch(() => setRows([]));
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="support-page">
      <PageHeader title="Support" subtitle="Protokoll der Super-Admin Support-/View-Sessions (read-only, serverseitig gebunden, 15 Min TTL)." />

      <div data-testid="support-note" className="mb-4 flex items-center gap-2 rounded-lg border border-fundio-border bg-fundio-subtle px-4 py-2 text-xs text-fundio-muted">
        <LifeBuoy className="h-4 w-4" />
        <span>Support-Sessions sind ausschliesslich <span className="font-semibold">read-only (VIEW)</span>. Sie werden im Kundendetail bzw. in «Interne QA» über «Kunden-Cockpit öffnen» gestartet.</span>
      </div>

      <Panel title="Support-Sessions" testid="support-panel" noPad>
        {rows === null ? (
          <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-fundio-gold" /></div>
        ) : rows.length === 0 ? (
          <div className="p-4"><EmptyState icon={LifeBuoy} title="Keine Support-Sessions" description="Es wurden noch keine Support-/View-Sessions gestartet." testid="support-empty" /></div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-fundio-border bg-fundio-subtle text-left text-xs font-semibold uppercase tracking-wider text-fundio-muted">
                <th className="px-5 py-3">Tenant</th>
                <th className="px-5 py-3">Super Admin</th>
                <th className="px-5 py-3">Modus</th>
                <th className="px-5 py-3">Gestartet</th>
                <th className="px-5 py-3">Gültig bis</th>
                <th className="px-5 py-3">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-fundio-border">
              {rows.map((s) => (
                <tr key={s.jti} data-testid={`support-row-${s.jti}`} className="bg-white">
                  <td className="px-5 py-3.5 font-mono text-xs text-fundio-ink">{s.tenant_id}</td>
                  <td className="px-5 py-3.5 text-fundio-muted">{s.super_admin_email}</td>
                  <td className="px-5 py-3.5"><span className="rounded-md border border-fundio-border bg-fundio-subtle px-2 py-0.5 font-mono text-xs text-fundio-muted">{s.mode}</span></td>
                  <td className="px-5 py-3.5 text-fundio-faint">{formatDate(s.created_at)}</td>
                  <td className="px-5 py-3.5 text-fundio-faint">{formatDate(s.expires_at)}</td>
                  <td className="px-5 py-3.5">
                    {s.active
                      ? <span className="text-xs font-medium text-status-success">Aktiv</span>
                      : s.revoked
                        ? <span className="text-xs font-medium text-fundio-muted">Beendet</span>
                        : <span className="text-xs font-medium text-fundio-faint">Abgelaufen</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Panel>
    </div>
  );
}
